'use client';

import { API_URLS } from '$constants/apis';
import { ErrorBoundary } from '@brahma/components';
import { useMutation } from '@brahma/hooks';
import { POST } from '@brahma/utils';
import { captureException } from '@sentry/nextjs';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
export default function Error({
  error,
  reset
}: {
  error: Error & {
    digest?: string;
  };
  reset: () => void;
}) {
  const pathname = usePathname();
  const {
    mutateAsync
  } = useMutation({
    url: API_URLS.errorLog,
    options: {
      method: POST
    }
  });
  useEffect(() => {
    captureException(error);
    mutateAsync({
      service: 'partner-portal',
      log: {
        message: `${error.message} at ${pathname} `,
        level: 'error',
        timeStamp: Date.now()
      }
    });
  }, [error]);
  return <ErrorBoundary error={error} reset={reset} data-sentry-element="ErrorBoundary" data-sentry-component="Error" data-sentry-source-file="error.tsx" />;
}